import HappyLittleHubspotLogo from './HappyLittleHubspotLogo.svg';
import HubspotDeleteIcon from './HubspotDelete.svg';
import HubspotSupportIcon from './HubspotSupport.svg';
import hubspotTheme from './theme';

export default {
  icons: {
    logo: HappyLittleHubspotLogo,
    delete: HubspotDeleteIcon,
    support: HubspotSupportIcon,
  },
  theme: hubspotTheme,
};
